import React from 'react';

const Footer = () => {
  return (
    <footer className='bg-neutral-100 border-t-[2px] border-dashed border-[#9c9b9b]'>
      <div className='container mx-auto px-4 sm:px-6 lg:px-8 py-7'>
        <div className='max-w-[1423px] mx-auto'>
          {/* Main Footer Content */}
          <div className='flex flex-col lg:flex-row items-start justify-center gap-[86px] mb-10'>
            {/* Left Column - Brand Description */}
            <div className='max-w-[384px]'>
              <div className='h-14 mb-4'></div>
              <p className='text-[15px] font-normal text-[#50576B] leading-[20.63px] max-w-[256px]'>
                Strategic web design, and
                <br />
                campaigns tailored to drive result
                <br />
                and conversions.
              </p>
            </div>

            {/* Middle Column - Company, Socials & Address */}
            <div className='flex gap-[40px] md:gap-[86px] flex-wrap'>
              {/* Company Links */}
              <div className='w-[125px]'>
                <h4 className='text-[16px] font-medium text-black mb-4 leading-[24px]'>
                  Company
                </h4>
                <ul className='space-y-[13px]'>
                  {[
                    'Services',
                    'Our Work',
                    'Achievements',
                    'FAQs',
                    'Brand',
                    'Contact',
                  ].map((link) => (
                    <li key={link}>
                      <a
                        href={`#${link.toLowerCase().replace(' ', '-')}`}
                        className='text-[16px] font-normal text-[#50576B] leading-[24px] hover:text-black transition-colors'
                      >
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Social Links */}
              <div>
                <h4 className='text-[15.4px] font-medium text-black mb-4 leading-[24px]'>
                  Socials
                </h4>
                <ul className='space-y-3'>
                  {['Email', 'Instagram', 'LinkedIn'].map((social) => (
                    <li key={social}>
                      <a
                        href={`#${social.toLowerCase()}`}
                        className='text-[16px] font-normal text-[#50576B] leading-[24px] hover:text-black transition-colors flex items-center gap-1'
                      >
                        {social}
                        <span className='text-[#50576B] rotate-[-45deg] inline-block'>
                          ↗
                        </span>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Office Address */}
              <div>
                <h4 className='text-[15.4px] font-medium text-black mb-4 leading-[24px]'>
                  Office
                </h4>
                <p className='text-[16px] font-normal text-[#50576B] leading-[24px] max-w-[200px]'>
                  501, Plot No: A-104, Swarna Palace
                  <br />
                  Mahadevapura, Gajularamaram
                  <br />
                  Hyderabad, Telangana 500014
                </p>
              </div>
            </div>

            {/* Right Column - Newsletter */}
            <div className='max-w-[384px]'>
              <h4 className='text-[15.8px] font-medium text-black mb-4 leading-[24px]'>
                Newsletter
              </h4>
              <p className='text-[15px] font-normal text-[#50576B] leading-[20.63px] mb-4 max-w-[320px]'>
                Stay ahead with design & marketing tips and
                <br />
                strategies that drive results.
              </p>
              {/* Newsletter Form */}
              <div className='bg-white border border-[#e5e7eb] rounded-full flex items-center gap-2 px-[13px] py-[7px] max-w-[448px]'>
                <span className='text-[16px] font-normal text-[#B0B0B0] leading-[24px]'>
                  @
                </span>
                <input
                  type='email'
                  placeholder='Enter your email...'
                  className='flex-1 px-0 py-[2px] text-[16px] font-normal text-[#99A1AF] border-none outline-none bg-transparent'
                  style={{ lineHeight: '100%' }}
                />
                <button className='w-16 h-10 flex items-center justify-center bg-[#0166F3] text-white rounded-full hover:opacity-90 transition-opacity'>
                  <svg
                    width='20'
                    height='20'
                    viewBox='0 0 20 20'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M7.5 15L12.5 10L7.5 5'
                      stroke='white'
                      strokeWidth='2'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className='pt-10 border-t border-[#F5F5F5]'>
            <div className='max-w-[1152px] mx-auto flex flex-col sm:flex-row justify-between items-start gap-4'>
              <p className='text-[16px] font-normal text-[#50576B] leading-[24px]'>
                ©2025 Quantum Soft All rights reserved
              </p>
              <div className='flex gap-8'>
                <a
                  href='#privacy'
                  className='text-[16px] font-normal text-[#50576B] leading-[24px] hover:text-black transition-colors'
                >
                  Privacy Policy
                </a>
                <a
                  href='#terms'
                  className='text-[16px] font-normal text-[#50576B] leading-[24px] hover:text-black transition-colors'
                >
                  Terms of Service
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
